type PairingStatusProps = {
  confirming: boolean;
  remainingLabel: string | null;
};

export function PairingStatus({ confirming, remainingLabel }: PairingStatusProps) {
  const statusText = confirming ? 'Code entered — finishing setup' : 'Waiting for confirmation';
  const tone = confirming ? 'confirming' : 'waiting';

  return (
    <p className={`pairing-status pairing-status--${tone}`} role="status">
      <span className="pairing-status__dot" aria-hidden>
        <span className="pairing-status__dot-core" />
        <span className="pairing-status__dot-pulse" />
      </span>
      <span className="pairing-status__label">{statusText}</span>
      {remainingLabel ? <span className="pairing-status__timer">· Code refreshes in {remainingLabel}</span> : null}
    </p>
  );
}
